module.exports = __webpack_public_path__ + "img/Chat-Icon.4deac1c6.png";